import { Component } from '@angular/core'
import { TranslateService } from '@app/shared/services/translate'
import locales from './locales'
import { CurrentOrganization } from '@app/shared/services/current-organization'

@Component({
  selector: 'support-page',
  templateUrl: './support.page.html',
  styleUrls: ['./support.page.scss'],
  standalone: false,
})
export class SupportPage {
  constructor(
    private translate: TranslateService,
    public currentOrganization: CurrentOrganization
  ) {}

  t = this.translate.create(locales)

  screenSections = [
    {
      title: this.t('screen.gettingStarted.title'),
      items: [
        {
          text: this.t('screen.gettingStarted.item1'),
          link: 'https://glabix.com/help/screen/kak-ustanovit-glabiks-ekran',
        },
        {
          text: this.t('screen.gettingStarted.item2'),
          link: 'https://glabix.com/help/screen/kak-zapisat-videosoobschenie',
        },
        {
          text: this.t('screen.gettingStarted.item3'),
          link: 'https://glabix.com/help/screen/vozmozhnosti-videosoobscheniya',
        },
      ],
    },
    {
      title: this.t('screen.editor.title'),
      items: [
        { text: this.t('screen.editor.item1'), link: 'https://glabix.com/help/screen/redaktirovanie-video' },
        { text: this.t('screen.editor.item2'), link: 'https://glabix.com/help/screen/kak-zagruzit-oblozhku-video' },
        { text: this.t('screen.editor.item3'), link: 'https://glabix.com/help/screen/kak-sozdat-promoknopki' },
      ],
    },
    {
      title: this.t('screen.library.title'),
      items: [
        { text: this.t('screen.library.item1'), link: 'https://glabix.com/help/screen/biblioteka-videosoobscheniy' },
        { text: this.t('screen.library.item2'), link: 'https://glabix.com/help/screen/dostupy-k-videosoobscheniyam' },
      ],
    },
  ]

  letuchkaSections = [
    {
      title: this.t('letuchka.organization.title'),
      items: [
        { text: this.t('letuchka.organization.item1'), link: 'https://glabix.com/help/letuchka/sozdanie-organizacii' },
        {
          text: this.t('letuchka.organization.item2'),
          link: 'https://glabix.com/help/letuchka/priglashenie-polzovateley',
        },
        { text: this.t('letuchka.organization.item3'), link: 'https://glabix.com/help/letuchka/spisok-polzovateley' },
        { text: this.t('letuchka.organization.item4'), link: 'https://glabix.com/help/letuchka/roli-i-prava-dostupa' },
        { text: this.t('letuchka.organization.item5'), link: 'https://glabix.com/help/letuchka/udalenie-organizacii' },
      ],
    },
    {
      title: this.t('letuchka.tasks.title'),
      items: [
        { text: this.t('letuchka.tasks.item1'), link: 'https://glabix.com/help/letuchka/sozdanie-zadachi' },
        { text: this.t('letuchka.tasks.item2'), link: 'https://glabix.com/help/letuchka/vidy-otobrazheniya-zadach' },
        { text: this.t('letuchka.tasks.item3'), link: 'https://glabix.com/help/letuchka/saydbar-zadachi' },
        { text: this.t('letuchka.tasks.item4'), link: 'https://glabix.com/help/letuchka/informaciya-o-zadache' },
        { text: this.t('letuchka.tasks.item5'), link: 'https://glabix.com/help/letuchka/chto-takoe-bloki-zadachi' },
      ],
    },
    {
      title: this.t('letuchka.letuchka.title'),
      items: [
        {
          text: this.t('letuchka.letuchka.item1'),
          link: 'https://glabix.com/help/letuchka/globalnaya-i-proektnaya-letuchka',
        },
        {
          text: this.t('letuchka.letuchka.item2'),
          link: 'https://glabix.com/help/letuchka/kak-dobavit-zadachu-ili-podzadachu-v-letuchku',
        },
        { text: this.t('letuchka.letuchka.item3'), link: 'https://glabix.com/help/letuchka/vhodyashchie-zadachi' },
        { text: this.t('letuchka.letuchka.item4'), link: 'https://glabix.com/help/letuchka/blokirovka' },
      ],
    },
  ]
}
